import { Component, Input } from '@angular/core';
import type { FullCalculateFormValues } from '@innogy/become-a-customer/shared';
import {
  type CalculateComponentRendering,
  CalculateComponentContent,
} from '@innogy/become-a-customer/shared/interfaces';
import type { TypedComponentRendering } from '@core/jss-models';
import { NgrxFormsModule, type FormGroupControls } from 'ngrx-forms';
import { CommonModule } from '@angular/common';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import { CommonUiFormsModule } from '@innogy/common-ui/forms';
import { CrntCheckbox } from '@essent/current-web-angular';

@Component({
  selector: 'wl-calculate-form-checkboxes',
  templateUrl: './calculate-form-checkboxes.component.html',
  styles: ['.dummyCheckboxForXpEditor { display: inline-block }'],
  standalone: true,
  imports: [
    CommonModule,
    AutomationIdDirective,
    CommonUiFormsModule,
    CrntCheckbox,
    NgrxFormsModule,
  ],
})
export class CalculateFormCheckboxesComponent {
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() rendering?: TypedComponentRendering<CalculateComponentRendering>;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input({ required: true }) content!: CalculateComponentContent;
  // eslint-disable-next-line @angular-eslint/prefer-signals
  @Input() controls?: FormGroupControls<FullCalculateFormValues> | undefined;

  get showDoubleMeter() {
    return !this.content.hideMeterCheckbox;
  }
}
